import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AccessDeniedScreen from './auth/AccessDeniedScreen';

export default function PrivateRoute() {
  const { currentUser, accessDenied, logout } = useAuth();
  const location = useLocation();
  
  console.log('🟢 PrivateRoute - Current location:', location.pathname);
  console.log('🟢 PrivateRoute - Current user:', currentUser);
  console.log('🟢 PrivateRoute - Access denied:', accessDenied);
  
  // Handle access denied scenarios
  if (accessDenied) {
    console.log('🔒 PrivateRoute - Access denied, showing access denied screen');
    return (
      <AccessDeniedScreen 
        accessDenied={accessDenied}
        onRetry={() => window.location.reload()}
        onLogout={logout}
      />
    );
  }
  
  // Handle unauthenticated users
  if (!currentUser) {
    console.log('🟢 PrivateRoute - No user, redirecting to login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  console.log('🟢 PrivateRoute - User authenticated, rendering outlet');
  return <Outlet />;
} 